import { render } from "./user-company-assignment.vue?vue&type=template&id=bf364092"
import script from "./user-company-assignment.vue?vue&type=script&lang=js"
export * from "./user-company-assignment.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__